import { core } from '@weenat/client'
import { useIntl } from '@weenat/wintl'
import { Slot, useNavigate } from 'app/routx-router'
import AlertsCTAIllustration from 'app/src/discover-menu/svg/AlertsCTAIllustration'
import { useIsAppAccessRestricted } from 'app/src/hooks/useIsAppAccessRestricted'
import useLogAndNavToUpgradePlans from 'app/src/hooks/useLogAndNavToUpgradePlans'
import CTAFullScreen from 'app/src/kit/CTAFullScreen'
import LockedFeat from 'app/src/kit/LockedFeat'
import AuthenticatedLayout from 'app/src/layouts/AuthenticatedLayout'
import MenuLayout from 'app/src/layouts/MenuLayout'
import ProtectedRoute from 'app/src/layouts/ProtectedRoute'

const FullScreenAlertCTA = () => {
  const nav = useNavigate()
  const { t } = useIntl()

  const logAndNavToUpgradePlans = useLogAndNavToUpgradePlans()

  return (
    <CTAFullScreen
      isOpen
      onClose={() => {
        nav('/')
      }}
      title={t('discover_menu.calls_to_action.alerts_title', { capitalize: true })}
      description={t('discover_menu.calls_to_action.alerts_description', {
        capitalize: true
      })}
      mainCTA={{
        label: t('actions.i_subscribe', { capitalize: true }),
        onPress: () => {
          logAndNavToUpgradePlans()
        }
      }}
      secondaryCTA={{
        label: t('discover_menu.calls_to_action.alert_secondary_cta', { capitalize: true }),
        to: '/discover/application/alerts'
      }}
      Illustration={<AlertsCTAIllustration />}
    />
  )
}

const AlertsLayout: FC = () => {
  const { hasAtLeastOneBilledOrg, isLoading: isLoadingOneBilledOrg } =
    core.me.useHasAtLeastOneBilledOrg()
  const { isRestricted, reason, isLoading: isLoadingRestriction } = useIsAppAccessRestricted()

  return (
    <AuthenticatedLayout>
      {isLoadingRestriction || isLoadingOneBilledOrg ? null : hasAtLeastOneBilledOrg &&
        !isRestricted ? (
        <MenuLayout>
          <Flex $flexDirection='column' $px='none'>
            <Slot />
          </Flex>
        </MenuLayout>
      ) : isRestricted && reason === 'freemium' ? (
        <FullScreenAlertCTA />
      ) : isRestricted && reason === 'downgrade' ? (
        <LockedFeat
          title='ecommerce.plans.restrictions.alerts_title'
          body='ecommerce.plans.restrictions.carousel_value_downgrade_message'
          showCTA
        />
      ) : null}
    </AuthenticatedLayout>
  )
}

// Components are split to make sure that the correct providers are rendered when rendering children
const ProtectedAlertLayout = () => {
  return (
    <ProtectedRoute>
      <AlertsLayout />
    </ProtectedRoute>
  )
}

export const Component = ProtectedAlertLayout
export default ProtectedAlertLayout
